



































import { Component, Prop, Vue } from 'vue-property-decorator';
import BpcDatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SearchAndOrder from '@core/interfaces/bpc-search-and-order';

@Component({
  name: 'bpc-renew-subscriptions-modal',
  components: {
    BpcDatePicker,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class RenewSubscriptionsModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'renew-modal' }) readonly modalId: string;
  @Prop({ type: String, default: 'subscription' }) readonly entity: string;
  @Prop({ type: Array, default: [] }) readonly ids: number[] | string[];

  @Prop({ type: Number, default: 0 }) readonly totalEntities: number;
  @Prop({ type: Boolean, default: false }) readonly checkedAll: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly filterModel;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly searchAndOrder: SearchAndOrder;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedEntities: string[];

  // Data
  public processAll: boolean = false;
  public isProcessing: boolean = false;

  get modalTitle(): string {
    return this.$t('subscriptions.renew-modal.title').toString();
  }

  get modalBody(): string {
    return this.$t('subscriptions.renew-modal.body').toString();
  }
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // Lifecycle
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // Methods
  closeModal() {
    this.$emit('close-modal');
    this.$bvModal.hide(this.modalId);
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  process() {
    this.listenToWebsocketRenewChannel();
    this.isProcessing = true;
    const path = `${this.$bpcApiRouteHelper.getEntityPath(this.entity)}/renew`;
    this.$bpcApi
      .post(path, {
        selectedItems: this.selectedEntities,
        filters: this.filterModel,
        searchAndOrder: this.searchAndOrder,
        processAll: this.processAll,
      })
      .subscribe(
        res => {
          console.log(res);
        },
        error => {
          this.isProcessing = false;
        },
      );
  }

  listenToWebsocketRenewChannel(): void {
    this.$bpcEcho
      .listenRenewSubscriptionChannel()
      .listen('.BPC\\Subscriptions\\Events\\SubscriptionsRenewedEvent', data => {
        this.$bpcEcho.leaveRenewSubscriptionChannel();
        this.$emit('processing-renew-end');
      });
  }
}
